import React from "react";

const basis = {
  display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "var(--ruimte-4)",
  fontFamily: "var(--font-tekst)", fontWeight: "var(--fw-semi)", letterSpacing: "0",
  borderRadius: "var(--radius)", border: "1px solid transparent", cursor: "pointer",
  transition: "var(--overgang-kleur), transform var(--duur-snel) var(--ease-standaard)",
  textDecoration: "none", whiteSpace: "nowrap",
};

const maten = {
  sm: { minHeight: 32, padding: "0 var(--ruimte-5)", fontSize: "var(--fs-sm)" },
  md: { minHeight: 36, padding: "0 var(--ruimte-6)", fontSize: "var(--fs-body)" },
  lg: { minHeight: 44, padding: "0 var(--ruimte-7)", fontSize: "var(--fs-body)" },
  touch: { minHeight: 44, width: "100%", padding: "0 var(--ruimte-7)", fontSize: "var(--fs-invoer-mobiel)" },
};

const varianten = {
  primair: { background: "var(--actie)", color: "#fff", boxShadow: "var(--schaduw-1)" },
  secundair: { background: "var(--wit)", color: "var(--text-strong)", borderColor: "var(--border-subtle)", boxShadow: "var(--schaduw-1)" },
  stil: { background: "transparent", color: "var(--text-body)" },
  gevaar: { background: "var(--alarm)", color: "#fff" },
  link: { background: "transparent", color: "var(--text-action)", padding: 0, minHeight: "auto", textDecoration: "underline", textUnderlineOffset: 2, boxShadow: "none" },
};

const hovers = {
  primair: { background: "var(--actie-hover)" },
  secundair: { background: "var(--surface-hover)" },
  stil: { background: "var(--surface-hover)" },
  gevaar: { background: "#8E231C" },
  link: { color: "var(--accent)" },
};

export function Button({ variant = "primair", size = "md", disabled, iconLeft, iconRight, as = "button", style, children, ...rest }) {
  const [hover, setHover] = React.useState(false);
  const [druk, setDruk] = React.useState(false);
  const Comp = as;
  return (
    <Comp
      disabled={Comp === "button" ? disabled : undefined}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setDruk(false); }}
      onMouseDown={() => setDruk(true)}
      onMouseUp={() => setDruk(false)}
      style={{ ...basis, ...maten[size], ...varianten[variant], ...(hover && !disabled ? hovers[variant] : null),
        transform: druk && !disabled && variant !== "link" ? "translateY(1px)" : "none",
        opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? "none" : undefined, ...style }}
      {...rest}
    >
      {iconLeft}{children}{iconRight}
    </Comp>
  );
}
